if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.sizeSelected = false;
      this.sizeFieldset = this.findSizeFieldset();
      this.dynamicCheckout = this.querySelector('.product-form__checkout');
      this.setupRequiredSizeSelection();
    }

    findSizeFieldset() {
      const productInfo = this.closest('[id^="ProductInfo-"]') || this.closest('.product__info-container') || this.parentElement;
      if (!productInfo) return null;

      return Array.from(productInfo.querySelectorAll('.product-form__input')).find((fieldset) => {
        const legend = fieldset.querySelector(':scope > .product-form__group-name, :scope > .product-form__group-size-heading .product-form__group-name');
        if (!legend) return false;
        const label = legend.textContent.replace(/\s+/g, ' ').trim().replace(/:.*$/, '').toLowerCase();
        return label === 'size';
      }) || null;
    }

    setupRequiredSizeSelection() {
      if (!this.sizeFieldset || !this.submitButton) return;

      this.dataset.requiresSize = 'true';
      this.lockForSize();

      this.sizeFieldset.querySelectorAll('input[type="radio"], select').forEach((control) => {
        control.addEventListener('change', () => {
          this.sizeSelected = true;
          this.handleErrorMessage();
          window.setTimeout(() => this.unlockAfterSizeSelection(), 80);
        });
      });
    }

    lockForSize() {
      if (!this.submitButton) return;
      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.dataset.sizeGate = 'true';
      const label = this.submitButton.querySelector('span');
      if (label) label.textContent = 'Select a Size';
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = true;
    }

    unlockAfterSizeSelection() {
      if (!this.submitButton || !this.sizeSelected) return;

      const label = this.submitButton.querySelector('span');
      const isSoldOut = label && /sold out/i.test(label.textContent);

      delete this.submitButton.dataset.sizeGate;
      if (!isSoldOut) {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-disabled');
        if (label) label.textContent = 'Add to Bag';
      }
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = false;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.sizeFieldset && !this.sizeSelected) {
        this.lockForSize();
        this.handleErrorMessage('Please select a size.');
        this.sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            if (this.sizeFieldset && !this.sizeSelected) {
              this.lockForSize();
            } else {
              this.submitButton.removeAttribute('aria-disabled');
            }
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
